/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    categoryIdSelected:0,
    defaultDataCategories:null
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_CATEGORY_ID = 'SET_CATEGORY_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setCategoriesId = (payload) => ({
  type: SET_CATEGORY_ID,
  payload,
})
export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_CATEGORY_ID:
        return {
          ...state,
          categoryIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataCategories: payload,
          }
     default:
       return state
   }
 }
 